import { UserPlusIcon } from "@heroicons/react/24/solid";
import { Button } from "@moe/oss/ui/button";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Navbar } from "@web/components/Navbar";
import { PersonaFormModal } from "@web/components/PersonaFormModal";
import { PersonaList } from "@web/components/persona/PersonaList";
import { useCreatePersona } from "@web/components/persona/use-create-persona";
import { useAppContext } from "@web/route-services/root/AppContext";
import { Sidepane } from "@web/route-services/settings/Sidepane";
import { motion } from "motion/react";

export const Route = createFileRoute("/settings/persona")({
  component: PersonaPage
});

/**
 * The personas settings page
 */
function PersonaPage() {
  const { createModal, access, isDesktopScreen } = useAppContext();

  const { data: personas = [], isPending } = useQuery({
    queryKey: ["personas"],
    queryFn: async () => {
      return await access.persona.getSelf();
    }
  });
  const createPersona = useCreatePersona();

  const handleNew = () => {
    createModal({
      content: (
        <PersonaFormModal
          title="New Persona"
          submit={{
            label: "Create",
            handle: async (formData) => {
              const insertData = {
                name: formData.name,
                description: formData.description,
                avatar: formData.avatar,
                isDefault: formData.isDefault
              };
              createPersona.mutate(insertData);
            }
          }}
        />
      )
    });
  };

  return (
    <div className="from-background-gradient via-background to-background text-tx-secondary flex h-screen w-screen bg-gradient-to-b text-sm antialiased antialiased">
      <Navbar />
      <div style={{ scrollbarGutter: "stable" }} className="scroll-home-page flex w-full flex-row overflow-auto py-4">
        {isDesktopScreen && <Sidepane />}
        <motion.div
          className="mt-20 flex h-full w-full flex-col items-center space-y-5 px-4 md:mt-0 md:justify-center md:px-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <h1 className="text-tx-primary text-2xl font-bold tracking-wide">Persona Settings</h1>
          <motion.div
            className="border-line bg-container-primary  flex w-full rounded-2xl border py-2  md:w-[32rem]"
            style={{
              minHeight: "6rem",
              maxHeight: "50vh"
            }}
          >
            <PersonaList personas={personas} isPending={isPending} />
          </motion.div>
          <Button onClick={handleNew}>
            <UserPlusIcon className="" />
            New
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
